import { render, staticRenderFns } from "./WebsitesListView.vue?vue&type=template&id=64bc8c28&scoped=true&"
import script from "./WebsitesListView.vue?vue&type=script&lang=js&"
export * from "./WebsitesListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bc8c28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64bc8c28')) {
      api.createRecord('64bc8c28', component.options)
    } else {
      api.reload('64bc8c28', component.options)
    }
    module.hot.accept("./WebsitesListView.vue?vue&type=template&id=64bc8c28&scoped=true&", function () {
      api.rerender('64bc8c28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/websites/WebsitesListView.vue"
export default component.exports